import { loadLocal } from '../../libs/browser/storage';
import * as sdk from 'matrix-js-sdk';
import auth from './auth';
import store from './store';
const BASE_URL = process.env.MATRIX_URL || '';
store.auth = loadLocal('chat');
store.phrase = '';
store.client = sdk.createClient({ baseUrl: BASE_URL });
// Handle crypto store IndexedDB errors that occur during sync
// These errors indicate database corruption and require clearing stores
window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = String(event.reason);
    const isIndexedDBCryptoError = errorMessage.includes('IndexedDB') ||
        errorMessage.includes('matrix_sdk_crypto') ||
        errorMessage.includes('get_inbound_group_session');
    if (isIndexedDBCryptoError) {
        console.error('Crypto store error detected, may require re-login:', event.reason);
        // Prevent the error from bubbling up to the console as "Uncaught"
        event.preventDefault();
    }
});
if (store.auth) {
    auth.loginWithToken(store.auth);
}
// Keep a live client reference even when auth recreates the underlying Matrix client.
const clientProxy = new Proxy({}, {
    get(_target, prop) {
        const value = store.client[prop];
        if (typeof value === 'function') {
            return value.bind(store.client);
        }
        return value;
    },
    set(_target, prop, value) {
        store.client[prop] = value;
        return true;
    },
});
export { auth };
export { waitForCryptoReady, isCryptoReady } from './cryptoReady';
export default clientProxy;
